import Features from './Features';

export class AppID {
    static PSWeb = new AppID('photoshop_web');
    static PSDesktop = new AppID('photoshop_cc');
    static Express = new AppID('free_spark');
    static Illustrator = new AppID('illustrator_cc');

    // ID used as fi_code, part of localization string keys
    id: string;

    constructor(id: string) {
        this.id = id;
    }

    public get application(): string {
        switch (this.id) {
            case AppID.Express.id:
                return 'Express';
                break;
            case AppID.Illustrator.id:
                return 'Illustrator';
                break;
            case AppID.PSWeb.id:
                return 'Photoshop Web';
                break;
            case AppID.PSDesktop.id:
            default:
                return 'Photoshop Desktop';
                break;
        }
    }
    public get appName(): string {
        switch (this.id) {
            case AppID.Express.id:
                return 'CCEX';
                break;
            case AppID.Illustrator.id:
                return 'ILST';
                break;
            case AppID.PSWeb.id:
                return 'PSW';
                break;
            case AppID.PSDesktop.id:
            default:
                return 'PHSP';
                break;
        }
    }
    public get sapCode(): string {
        switch (this.id) {
            case AppID.Express.id:
                return 'CCEX';
                break;
            case AppID.Illustrator.id:
                return 'ILST';
                break;
            case AppID.PSWeb.id:
            case AppID.PSDesktop.id:
            default:
                return 'PHSP';
                break;
        }
    }

    public aem_id(docId: string): string {
        let base = '';
        switch (this.id) {
            case AppID.Express.id:
                base = 'express';
                break;
            case AppID.Illustrator.id:
                base = 'illustrator';
                break;
            case AppID.PSWeb.id:
            case AppID.PSDesktop.id:
            default:
                base = 'photoshop';
                break;
        }
        return base + '/how-to/in-app/' + docId;
    }

    public isEqual(appId: AppID): boolean {
        return appId.id == this.id;
    }

    public preview(docId: string, urn: string): string {
        const base = process.env.EXPRESS_PREVIEW_URL;
        // urn:aaid:sc:VA6C2:6d08d30f-a763-338f-bf91-39d9aead6978
        // https://stage.projectx.corp.adobe.com/design/template/<TEMPLATE URN>?learn=exercise:<DOC ID>:preview
        // https://new.express.adobe.com/design/template/<TEMPLATE URN>?learn=exercise:<DOC ID>:preview
        // https://stage.projectx.corp.adobe.com/cc-learn

        // For when urn is ""
        if (urn == '') {
            // https://stage.projectx.corp.adobe.com/cc-learn/new?learn=exercise:<DOC_ID>:preview
            // https://new.express.adobe.com/cc-learn/new?learn=exercise:<DOC_ID>:preview
            return base + '/new?learn=exercise:' + docId + ':preview';
        }
        return base + '/design/template/' + urn + '?learn=exercise:' + docId + ':preview';
    }

    // Get all the allowed apps, might be limited due to features that are not public yet and require a feature flag to be present
    static all(filter: boolean = true): AppID[] {
        let apps: AppID[] = [AppID.Express, AppID.Illustrator, AppID.PSDesktop, AppID.PSWeb];

        // if (!filter || Features.check(Features.Name.ILLUSTRATOR)) {
        //   apps.push(AppID.Illustrator)
        // }

        return apps;
    }

    static find(id: string): AppID | undefined {
        if (id == 'spark') {
            return AppID.Express;
        } // Handle old dataconverion
        return AppID.all().find((obj) => obj.id == id);
    }

    static findByAppName(name: string): AppID | undefined {
        return AppID.all().find((obj) => obj.appName == name);
    }
}

export default AppID;
